import { RouteRecordRaw } from 'vue-router';

const maintenanceRoutes: RouteRecordRaw[] = [
   {
      path: '/maintenance',
      name: 'maintenance-index',
      component: () => import('@/modules/maintenance/pages/Index.vue'),
   },
];

export default maintenanceRoutes;
